import { call, all, put, takeLatest, select } from 'redux-saga/effects';
import AsyncStorage from '@react-native-community/async-storage';

import notification from '../../../services/notification';
import domainService from '../../../services/modules/domain/domain-service';
import tenantService from './tenant-service';
import * as tenantActions from './tenant-actions';
import {
  GET_BY_ID_REQUEST,
  UPDATE_IMAGE_TENANT,
  UPDATE_IMAGE_SUBSIDIARY,
  UPDATE_PRICE_TABLE,
  GET_ALL_REQUEST,
  TEST_TENANT_CONNECTION
} from './tenant-constants';
import { ISA_ERROR, ISA_TENANT_ID } from '../../../constants';
import { formatMessage } from '~/i18n/translate';
import { AppStateType } from '../root-reducer';

export function* getTenant() {
  try {
    yield put(tenantActions.setLoadingData(true));

    const user = yield select((state: AppStateType) => state.auth.user);

    const tenantId = yield AsyncStorage.getItem(ISA_TENANT_ID);
    const { data } = yield call(tenantService.getTenant, tenantId);
    const { data: subsidiaries } = yield call(domainService.getSubsidiaries, {
      userSubsidiaryFilter: user?.userSubsidiaries ?? []
    });
    if (data) {
      yield put(tenantActions.getTenantSuccess({ ...data, subsidiaries }));
    }
    yield put(tenantActions.setLoadingData(false));
  } catch (error) {
    yield put(tenantActions.setLoadingData(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* updateImageTenant({ file }: any) {
  const toast: any = notification.loading(formatMessage('tenantFormSendImage'));
  try {
    const tenantId = yield AsyncStorage.getItem(ISA_TENANT_ID);
    yield call(tenantService.putImageTenant, tenantId, file);
    toast.close();

    yield put(tenantActions.getTenantRequest());
  } catch (error) {
    toast.close();
    yield put({ type: ISA_ERROR, error });
  }
}

export function* updateImageSubdsiary({ subsidiaryId, file }: any) {
  try {
    yield call(tenantService.putImageSubsidiary, subsidiaryId, file);

    yield put(tenantActions.getTenantRequest());
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  }
}

export function* updatePriceTableCode({ payload }: any) {
  const toast: any = notification.loading(formatMessage('tenantFormPriceTableCodeSaving'));
  try {
    const user = yield select((state: AppStateType) => state.auth.user);

    yield call(tenantService.putPriceTableCodeSubsidiary, payload);

    const { data: subsidiaries } = yield call(domainService.getSubsidiaries, {
      userSubsidiaryFilter: user?.userSubsidiaries ?? []
    });
    if (subsidiaries) {
      yield put(tenantActions.getTenantSuccess({ subsidiaries }));
    }
    toast.close();
    yield call(notification.success, formatMessage('tenantFormPriceTableCodeSaveSuccess'));
  } catch (error) {
    toast.close();
    yield put({ type: ISA_ERROR, error });
  }
}

export function* getListShankya({ filters }: any) {
  try {
    yield put(tenantActions.setLoadingList(true));

    const { rowsPerPage, page, order, orderBy } = yield select((state: AppStateType) => state.tenant.list);

    const pagination = {
      skip: page === 0 ? 0 : page * rowsPerPage,
      limit: rowsPerPage,
      order,
      orderBy
    };

    const filterParams = {
      subsidiaryExternalCodes: filters?.subsidiaries?.map(s => s.externalCode).join(',') || undefined
    };

    const [{ data }, { data: count }] = yield all([
      call(tenantService.getListShankyaConfig, {
        ...pagination,
        ...filterParams
      }),
      call(tenantService.getListShankyaCount, {
        ...filterParams
      })
    ]);

    yield put(
      tenantActions.getAllSuccess({
        rows: data,
        count: count.count
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(tenantActions.setLoadingList(false));
  }
}

export function* getTestConnectionTenant() {
  const toast: any = notification.loading(formatMessage('tenantTestConnectionAlert'));
  yield put(tenantActions.getTestConnectionTenantLoading(true));
  try {
    const tenantId = yield AsyncStorage.getItem(ISA_TENANT_ID);
    yield call(tenantService.getTestConnectionTenant, tenantId);
    toast.close();
    yield put(tenantActions.getTestConnectionTenantLoading(false));
    yield call(notification.success, formatMessage('tenantTestConnectionAlertSuccess'));
  } catch (error) {
    toast.close();
    yield put(tenantActions.getTestConnectionTenantLoading(false));
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(tenantActions.getTestConnectionTenantLoading(false));
  }
}

export default all([
  takeLatest(GET_ALL_REQUEST, getListShankya),
  takeLatest(GET_BY_ID_REQUEST, getTenant),
  takeLatest(UPDATE_IMAGE_TENANT, updateImageTenant),
  takeLatest(UPDATE_IMAGE_SUBSIDIARY, updateImageSubdsiary),
  takeLatest(UPDATE_PRICE_TABLE, updatePriceTableCode),
  takeLatest(TEST_TENANT_CONNECTION, getTestConnectionTenant)
]);
